import jump from 'jump.js'

import FictivSymbol from '~/lib/FictivSymbol'

const SCROLL_TO = FictivSymbol('SCROLL_TO')

export function createScrollMiddleware() {
    return () => next => action => {
        if (action.type === SCROLL_TO) {
            jump('body', { duration: 250 })
        }
        return next(action)
    }
}
